import Cookies from "universal-cookie";

const cookies = new Cookies();

/* ==================== Types ==================== */

type Token = string;

/* ==================== Access Token ==================== */

export function setToken(token: Token): void {
  cookies.set("access_token", token, {
    path: "/",
    maxAge: 60 * 60 * 24,
  });
}

export function getToken(): Token | undefined {
  return cookies.get("access_token");
}

export function clearToken(): void {
  cookies.remove("access_token", { path: "/" });
}

/* ==================== Refresh Token ==================== */

export function setRefreshToken(refreshToken: Token): void {
  cookies.set("refresh_token", refreshToken, {
    path: "/",
    maxAge: 60 * 60 * 24,
  });
}

export function getRefreshToken(): Token | undefined {
  return cookies.get("refresh_token");
}

export function clearRefreshToken(): void {
  cookies.remove("refresh_token", { path: "/" });
}

/* ==================== Utils ==================== */

export function clearAllTokens(): void {
  clearToken();
  clearRefreshToken();
}
